import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const devLovableUi = process.env.REACT_APP_DEV_LOVABLE_UI === 'true';
if (devLovableUi) {
  document.documentElement.classList.add('dev-lovable');
}

// Stage G is available only in an explicitly selected development build.
const App = process.env.REACT_APP_STAGE_G === 'true'
  ? require('./StageGApp').default
  : require('./App').default;

const resizeObserverLoopMessages = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

window.addEventListener(
  'error',
  (event) => {
    if (resizeObserverLoopMessages.includes(event.message)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
